import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ParentProvider } from './context/ParentContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Students from './pages/Students';
import Evaluations from './pages/Evaluations';
import EvaluationReports from './pages/EvaluationReports';
import EvaluationSettings from './pages/EvaluationSettings';
import EvaluationDetail from './pages/EvaluationDetail';
import Bulletins from './pages/Bulletins';
import Bulletin from './pages/Bulletin';
import EvaluationCreate from './pages/EvaluationCreate';
import EvaluationEntry from './pages/EvaluationEntry';
import Finance from './pages/Finance';
import Finance1 from './pages/Finance-1';
import Tresorerie from './pages/Tresorerie';
import ValidationNotes from './pages/ValidationNotes';
import DashboardEnseignant from './pages/DashboardEnseignant';
import GestionPaiements from './pages/GestionPaiements';
import Annonces from './pages/Annonces';
import CommunicationParent from './pages/CommunicationParent';
import GestionRoles from './pages/GestionRoles';
import DashboardParent from './pages/DashboardParent';
import EspaceParent from './pages/EspaceParent';
import Classements from './pages/Classements';
import EvaluationPrescolaire from './pages/EvaluationPrescolaire';
import BulletinPrescolaire from './pages/BulletinPrescolaire';
import BulletinElementaire from './pages/BulletinElementaire';
import BulletinSecondaire from './pages/BulletinSecondaire';
import RapportAbsences from './pages/RapportAbsences';
import HoraireCours from './pages/HoraireCours';
import PortailEnseignant from './pages/PortailEnseignant';
import Communication from './pages/Communication';
import CahierTexte from './pages/CahierTexte';
import Fournisseurs from './pages/Fournisseurs';
import Stocks from './pages/Stocks';
import Echeanciers from './pages/Echeanciers';
import Bourses from './pages/Bourses';
import Transferts from './pages/Transferts';
import ModelsDocuments from './pages/ModelsDocuments';
import Sante from './pages/Sante';
import VieScolaire from './pages/VieScolaire';
import Formulaires from './pages/Formulaires';
import Contrats from './pages/Contrats';
import Conges from './pages/Conges';
import Registre from './pages/Registre';
import LibraryEmprunts from './pages/LibraryEmprunts';
import LibraryRetards from './pages/LibraryRetards';
import LibraryCatalogue from './pages/LibraryCatalogue';
import LibraryHistorique from './pages/LibraryHistorique';
import LibraryEleve from './pages/LibraryEleve';
import LibraryParametres from './pages/LibraryParametres';
import Attendance from './pages/Attendance';
import Timetable from './pages/Timetable';
import TimetableGrid from './pages/TimetableGrid';
import TimetableCalendar from './pages/TimetableCalendar';
import TimetablePublication from './pages/TimetablePublication';
import TimetableSettings from './pages/TimetableSettings';
import TimetableHistory from './pages/TimetableHistory';
import FacturesInscription from './pages/FacturesInscription';

import Library from './pages/Library';
import Staff from './pages/Staff';
import Assets from './pages/Assets';
import Rooms from './pages/Rooms';
import RegistryPage from './pages/RegistryPage';
import Establishment from './pages/Establishment';
import Admissions from './pages/Admissions';
import Structure from './pages/Structure';
import { REGISTRIES } from './config/registries';
import StaffAttendance from './pages/StaffAttendance';
import { ConfirmHost } from './utils/confirm';
import { useAuth } from './context/AuthContext';
import { PlatformOverview, PlatformTenants, PlatformPlans, PlatformSubscriptions } from './pages/Platform';
import { PLATFORM_REGISTRIES } from './config/platformRegistries';

import PedagogieDashboard from './pages/PedagogieDashboard';
import Competences from './pages/Competences';
import ThemePreview from './pages/ThemePreview';

function Home() {
  const { user } = useAuth();
  return <Navigate to={user?.roles?.includes('SUPER_ADMIN') ? '/plateforme' : '/dashboard'} replace />;
}

function DashboardRouter() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const roles = user?.roles || [];
  if (roles.includes('PARENT')) return <DashboardParent />;
  if (roles.includes('ENSEIGNANT') && !roles.includes('ADMINISTRATEUR') && !roles.includes('PROVISEUR') && !roles.includes('CENSEUR') && !roles.includes('SECRETAIRE') && !roles.includes('COMPTABLE')) return <DashboardEnseignant />;
  return <Dashboard />;
}

function AnnoncesRouter() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  if ((user?.roles || []).includes('PARENT')) return <CommunicationParent />;
  return <Annonces />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <ProtectedRoute>
                <ParentProvider>
                  <Layout />
                </ParentProvider>
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<DashboardRouter />} />
            <Route path="/eleves" element={<Students />} />
            {/* Pédagogie */}
            <Route path="/pedagogie" element={<Evaluations />} />
            <Route path="/pedagogie/rapports" element={<EvaluationReports />} />
            <Route path="/pedagogie/tableau-de-bord" element={<PedagogieDashboard />} />
            <Route path="/pedagogie/competences" element={<Competences />} />
            <Route path="/pedagogie/parametres" element={<EvaluationSettings />} />
            <Route path="/pedagogie/bulletins" element={<Bulletins />} />

            {/* Finance */}
            <Route path="/finance" element={<Finance />} />
            <Route path="/finance/tresorerie" element={<Tresorerie />} />
            <Route path="/finance/paiements" element={<GestionPaiements />} />
            <Route path="/finance/factures-inscription" element={<FacturesInscription />} />
            <Route path="/finance/frais" element={<Finance1 />} />
            <Route path="/pedagogie/validation-notes" element={<ValidationNotes />} />
            <Route path="/dashboard-enseignant" element={<DashboardEnseignant />} />
            <Route path="/communication/annonces" element={<AnnoncesRouter />} />
            <Route path="/admin/roles" element={<GestionRoles />} />
            <Route path="/parent/enfant/:studentId" element={<EspaceParent />} />
            <Route path="/parent/bulletin/:studentId" element={<EspaceParent />} />
            <Route path="/parent/presences/:studentId" element={<EspaceParent />} />
            <Route path="/parent/paiements/:studentId" element={<EspaceParent />} />
            <Route path="/pedagogie/classements" element={<Classements />} />
            <Route path="/evaluations/prescolaire/new" element={<EvaluationPrescolaire />} />
            <Route path="/bulletins/prescolaire/:obsId" element={<BulletinPrescolaire />} />
            <Route path="/bulletins/prescolaire-vide/:studentId" element={<BulletinPrescolaire />} />
            <Route path="/bulletins/:studentId" element={<BulletinElementaire />} />
            <Route path="/bulletins/detail/:studentId" element={<BulletinSecondaire />} />
            <Route path="/presences/rapports" element={<RapportAbsences />} />
            <Route path="/emploi-du-temps/horaire" element={<HoraireCours />} />
            <Route path="/portail-enseignant" element={<PortailEnseignant />} />

            {/* Bibliothèque */}
            <Route path="/bibliotheque" element={<LibraryCatalogue />} />
            <Route path="/bibliotheque/emprunts" element={<LibraryEmprunts />} />
            <Route path="/bibliotheque/retards" element={<LibraryRetards />} />
            <Route path="/bibliotheque/catalogue" element={<LibraryCatalogue />} />
            <Route path="/bibliotheque/historique" element={<LibraryHistorique />} />
            <Route path="/bibliotheque/eleve" element={<LibraryEleve />} />
            <Route path="/bibliotheque/parametres" element={<LibraryParametres />} />


            {/* Établissement */}
            <Route path="/etablissement" element={<Establishment />} />
            <Route path="/etablissement/admissions" element={<Admissions />} />
            <Route path="/etablissement/structure" element={<Structure />} />

            {/* Support */}
            <Route path="/support/materiel" element={<Assets />} />
            <Route path="/support/salles" element={<Rooms />} />

            {/* Communication */}
            <Route path="/communication" element={<Communication />} />
            <Route path="/communication/personnel" element={<Staff />} />
            <Route path="/communication/presences-personnel" element={<Attendance />} />




            <Route path="/evaluations/new" element={<EvaluationCreate />} />
            <Route path="/evaluations/:id/saisie" element={<EvaluationEntry />} />
            <Route path="/evaluations/:id" element={<EvaluationDetail />} />



            <Route path="/presences" element={<Attendance />} />
            <Route path="/emploi-du-temps" element={<TimetableGrid />} />
            <Route path="/emploi-du-temps/calendrier" element={<TimetableCalendar />} />
            <Route path="/emploi-du-temps/publication" element={<TimetablePublication />} />
            <Route path="/emploi-du-temps/parametres" element={<TimetableSettings />} />
            <Route path="/emploi-du-temps/historique" element={<TimetableHistory />} />


            <Route path="/structure" element={<Structure />} />

            <Route path="/presences-personnel" element={<StaffAttendance />} />
            <Route path="/pedagogie/cahier-texte" element={<CahierTexte />} />
            <Route path="/finance/fournisseurs" element={<Fournisseurs />} />
            <Route path="/finance/stocks" element={<Stocks />} />
            <Route path="/finance/echeanciers" element={<Echeanciers />} />
            <Route path="/finance/bourses" element={<Bourses />} />
            <Route path="/etablissement/transferts" element={<Transferts />} />
            <Route path="/etablissement/documents" element={<ModelsDocuments />} />
            <Route path="/support/sante" element={<Sante />} />
            <Route path="/support/vie-scolaire" element={<VieScolaire />} />
            <Route path="/support/formulaires" element={<Formulaires />} />
            <Route path="/communication/contrats" element={<Contrats />} />
            <Route path="/communication/registre" element={<Registre />} />
            <Route path="/communication/conges" element={<Conges />} />


            <Route path="/vie-scolaire" element={<RegistryPage config={REGISTRIES.schoolLife} />} />
            <Route path="/sante" element={<RegistryPage config={REGISTRIES.health} />} />
            <Route path="/registre-employeur" element={<RegistryPage config={REGISTRIES.employerRegister} />} />
            <Route path="/formulaires" element={<RegistryPage config={REGISTRIES.adminForms} />} />
            <Route path="/fournisseurs" element={<RegistryPage config={REGISTRIES.suppliers} />} />
            <Route path="/transferts" element={<RegistryPage config={REGISTRIES.transfers} />} />
            <Route path="/modeles-documents" element={<RegistryPage config={REGISTRIES.documentTemplates} />} />
            <Route path="/cahier-texte" element={<RegistryPage config={REGISTRIES.lessonBooks} />} />

            <Route path="/stocks" element={<RegistryPage config={REGISTRIES.stocks} />} />
            <Route path="/bourses" element={<RegistryPage config={REGISTRIES.scholarships} />} />
            <Route path="/echeanciers" element={<RegistryPage config={REGISTRIES.feeSchedules} />} />
            <Route path="/contrats-rh" element={<RegistryPage config={REGISTRIES.hrContracts} />} />
            <Route path="/plateforme" element={<PlatformOverview />} />
            <Route path="/plateforme/ecoles" element={<PlatformTenants />} />
            <Route path="/plateforme/plans" element={<PlatformPlans />} />
            <Route path="/plateforme/abonnements" element={<PlatformSubscriptions />} />
            <Route path="/plateforme/support" element={<RegistryPage config={PLATFORM_REGISTRIES.support} basePath="/platform/registry" />} />
            <Route path="/plateforme/supervision" element={<RegistryPage config={PLATFORM_REGISTRIES.monitoring} basePath="/platform/registry" />} />
            <Route path="/plateforme/securite" element={<RegistryPage config={PLATFORM_REGISTRIES.security} basePath="/platform/registry" />} />
            <Route path="/plateforme/configuration" element={<RegistryPage config={PLATFORM_REGISTRIES.config} basePath="/platform/registry" />} />
            <Route path="/plateforme/marketing" element={<RegistryPage config={PLATFORM_REGISTRIES.marketing} basePath="/platform/registry" />} />
            <Route path="/plateforme/analytique" element={<RegistryPage config={PLATFORM_REGISTRIES.analytics} basePath="/platform/registry" />} />
            <Route path="/plateforme/facturation" element={<RegistryPage config={PLATFORM_REGISTRIES.billing} basePath="/platform/registry" />} />
          </Route>
          <Route path="*" element={<Home />} />

          <Route path="/theme-preview" element={<ThemePreview />} />
        </Routes>
      </BrowserRouter>
      <ConfirmHost />
    </AuthProvider>
  );
}
